// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../node_modules/rescript/lib/es6/list.js";
import * as Js_dict from "../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as DateTime$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/DateTime.bs.js";
import * as UrlUtils$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/UrlUtils.bs.js";
import * as ErrorUtils$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function getRnrDashboard(url) {
  var match = url.path;
  var uuid;
  if (!match) {
    return ;
  }
  if (match.hd !== "rnr") {
    return ;
  }
  var match$1 = match.tl;
  if (!match$1) {
    return ;
  }
  var match$2 = match$1.tl;
  var uuid$1 = match$1.hd;
  if (match$2) {
    var match$3 = match$2.tl;
    if (match$3) {
      if (match$3.tl) {
        return ;
      }
      uuid = uuid$1;
    } else {
      uuid = uuid$1;
    }
  } else {
    uuid = uuid$1;
  }
  var urlParams = UrlUtils$Catalyst.getURLParams(url.search);
  var authToken = Belt_Option.mapWithDefault(Js_dict.get(urlParams, "auth_token"), "Auth_Token", (function (x) {
          return x;
        }));
  var language = Belt_Option.mapWithDefault(Js_dict.get(urlParams, "lang"), "en", (function (x) {
          if (List.mem(x, {
                  hd: "en",
                  tl: {
                    hd: "hi",
                    tl: {
                      hd: "kn",
                      tl: {
                        hd: "ta",
                        tl: {
                          hd: "te",
                          tl: {
                            hd: "mr",
                            tl: /* [] */0
                          }
                        }
                      }
                    }
                  }
                })) {
            return x;
          } else {
            return "en";
          }
        }));
  var version = Belt_Option.mapWithDefault(Js_dict.get(urlParams, "version_name"), "", (function (x) {
          return x;
        }));
  var version_code = Belt_Option.mapWithDefault(Js_dict.get(urlParams, "version_code"), "", (function (x) {
          return x;
        }));
  return {
          TAG: /* RnrConfigLoader */9,
          _0: uuid,
          _1: authToken,
          _2: language,
          _3: version,
          _4: version_code
        };
}

function mapRewardCategoryToUrlString(rewardCategory) {
  switch (rewardCategory) {
    case /* CustomerService */0 :
        return "customer_service_reward";
    case /* LoginActivity */1 :
        return "login_hours_reward";
    case /* OrderFulfillment */2 :
        return "order_fulfillment_reward";
    
  }
}

function mapUrlStringToRewardCategory(rewardCategoryStr) {
  switch (rewardCategoryStr) {
    case "customer_service_reward" :
        return /* CustomerService */0;
    case "login_hours_reward" :
        return /* LoginActivity */1;
    case "order_fulfillment_reward" :
        return /* OrderFulfillment */2;
    default:
      return ErrorUtils$Catalyst.raiseError("RnrRouteManager.RouteManager.mapUrlStringToRewardCategory", "No acceptable reward category found", rewardCategoryStr);
  }
}

function getRouteFromURL(url) {
  var match = url.path;
  if (!match) {
    return ;
  }
  if (match.hd !== "rnr") {
    return ;
  }
  var match$1 = match.tl;
  if (!match$1) {
    return ;
  }
  var match$2 = match$1.tl;
  var uuid = match$1.hd;
  if (!match$2) {
    return {
            TAG: /* RnrHome */0,
            _0: uuid,
            _1: undefined,
            _2: undefined,
            _3: undefined
          };
  }
  var milestone = match$2.hd;
  switch (milestone) {
    case "award_history" :
        if (!match$2.tl) {
          return {
                  TAG: /* AwardHistory */3,
                  _0: uuid,
                  _1: undefined
                };
        }
        break;
    case "customer_service_reward" :
        if (!match$2.tl) {
          return {
                  TAG: /* RnrReward */2,
                  _0: uuid,
                  _1: mapUrlStringToRewardCategory("customer_service_reward")
                };
        }
        break;
    case "login_hours_reward" :
        if (!match$2.tl) {
          return {
                  TAG: /* RnrReward */2,
                  _0: uuid,
                  _1: mapUrlStringToRewardCategory("login_hours_reward")
                };
        }
        break;
    case "order_fulfillment_reward" :
        if (!match$2.tl) {
          return {
                  TAG: /* RnrReward */2,
                  _0: uuid,
                  _1: mapUrlStringToRewardCategory("order_fulfillment_reward")
                };
        }
        break;
    case "reward_history" :
        if (!match$2.tl) {
          return {
                  TAG: /* RewardHistory */1,
                  _0: uuid,
                  _1: undefined,
                  _2: undefined
                };
        }
        break;
    default:
      
  }
  var match$3 = match$2.tl;
  if (match$3 && match$3.hd === "tnc" && !match$3.tl) {
    return {
            TAG: /* Tnc */4,
            _0: uuid,
            _1: milestone
          };
  }
  
}

function getURLFromRoute(authToken, lang, version, route) {
  switch (route.TAG | 0) {
    case /* RnrHome */0 :
        var uuid = route._0;
        var categoryParam = Belt_Option.mapWithDefault(route._1, "", (function (x) {
                return x;
              }));
        var dateParam = Belt_Option.mapWithDefault(route._2, "", (function (x) {
                return DateTime$Catalyst.toString("YYYY-MM-DD", x);
              }));
        var milestoneParam = Belt_Option.mapWithDefault(route._3, "Star", (function (x) {
                return x;
              }));
        if (categoryParam !== "" && dateParam !== "") {
          return "/rnr/" + (uuid + ("?date=" + (dateParam + ("&category=" + (categoryParam + ("&auth_token=" + (authToken + ("&lang=" + (lang + "#rewards")))))))));
        } else if (milestoneParam !== "") {
          return "/rnr/" + (uuid + ("/award?milestone=" + (milestoneParam + ("&auth_token=" + (authToken + ("&version_name=" + (version + ("&lang=" + (lang + "#awards")))))))));
        } else {
          return "/rnr/" + uuid;
        }
    case /* RewardHistory */1 :
        var uuid$1 = route._0;
        var categoryParam$1 = Belt_Option.mapWithDefault(route._1, "", (function (x) {
                return x;
              }));
        var dateParam$1 = Belt_Option.mapWithDefault(route._2, "", (function (x) {
                return DateTime$Catalyst.toString("YYYY-MM-DD", x);
              }));
        if (categoryParam$1 !== "" && dateParam$1 !== "") {
          return "/rnr/" + (uuid$1 + ("/reward_history?date=" + (dateParam$1 + ("&category=" + (categoryParam$1 + ("&auth_token=" + (authToken + ("&lang=" + (lang + "#rewards")))))))));
        } else {
          return "/rnr/" + (uuid$1 + "/reward_history");
        }
    case /* RnrReward */2 :
        return "/rnr/" + (route._0 + ("/" + mapRewardCategoryToUrlString(route._1)));
    case /* AwardHistory */3 :
        var milestone = route._1;
        var uuid$2 = route._0;
        var milestoneParam$1 = milestone !== undefined ? milestone : "";
        if (milestoneParam$1 !== "") {
          return "/rnr/" + (uuid$2 + ("/award_history?milestone=" + (milestoneParam$1 + ("&auth_token=" + (authToken + ("&version_name=" + (version + ("&lang=" + (lang + "#awards")))))))));
        } else {
          return "/rnr/" + (uuid$2 + "/award_history#awards");
        }
    case /* Tnc */4 :
        return "/rnr/" + (route._0 + ("/" + (route._1 + "/tnc")));
    
  }
}

var RouteManager = {
  getRnrDashboard: getRnrDashboard,
  getRouteFromURL: getRouteFromURL,
  getURLFromRoute: getURLFromRoute
};

export {
  RouteManager ,
  
}
/* DateTime-Catalyst Not a pure module */
